var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRealityChecks24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_reality_checks24x24",
    transform: "translate(-5.999 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24740",
    "data-name": "Group 24740",
    transform: "translate(5.999 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22641",
    "data-name": "Group 22641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22398",
    "data-name": "Group 22398",
    transform: "translate(2.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42268",
    "data-name": "Path 42268",
    d: "M89.367,73.191a5.982,5.982,0,0,1-.848-3.093V66.961a5.04,5.04,0,0,0-1.28-3.405,4.168,4.168,0,0,0-2.562-1.369V61H83.633v1.188a4.715,4.715,0,0,0-3.815,4.821V70.1a5.982,5.982,0,0,1-.848,3.093l-1,1.654h4.72a1.521,1.521,0,0,0,2.953,0h4.72Zm-9.445.5a7.234,7.234,0,0,0,.941-3.593V67.009a3.529,3.529,0,0,1,3.294-3.7h.011A3.134,3.134,0,0,1,86.5,64.371a3.83,3.83,0,0,1,.972,2.585v3.136a7.233,7.233,0,0,0,.941,3.593Z",
    transform: "translate(-77.973 -61)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22400",
    "data-name": "Group 22400",
    transform: "translate(15.548 3.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42269",
    "data-name": "Path 42269",
    d: "M449.134,153.468l-.817.822a4.476,4.476,0,0,1,.049,6.252l.829.809a5.644,5.644,0,0,0-.061-7.884Z",
    transform: "translate(-448.317 -153.467)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22402",
    "data-name": "Group 22402",
    transform: "translate(13.915 5.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42270",
    "data-name": "Path 42270",
    d: "M406.708,195.9l-.817.822a2.141,2.141,0,0,1,.016,3l.826.813a3.308,3.308,0,0,0-.025-4.632Z",
    transform: "translate(-405.891 -195.9)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22404",
    "data-name": "Group 22404",
    transform: "translate(0 3.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42271",
    "data-name": "Path 42271",
    d: "M2.452,154.291l-.817-.822a5.644,5.644,0,0,0-.061,7.884l.829-.809a4.476,4.476,0,0,1,.049-6.252Z",
    transform: "translate(.001 -153.469)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22406",
    "data-name": "Group 22406",
    transform: "translate(2.31 5.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42272",
    "data-name": "Path 42272",
    d: "M61.775,196.717l-.817-.822a3.308,3.308,0,0,0-.025,4.632l.826-.813a2.141,2.141,0,0,1,.017-3Z",
    transform: "translate(-60 -195.895)",
    fill: "#999"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRealityChecks24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_reality_checks24x24.11ed421eca259a63449a52a08dd8f542.svg";